









import DB from "../shared/DB";
import { AccountState } from "../shared/types/AccountState";
import Icon from "@/components/Icon.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
	components: {
		Icon
	}
})

export default class AccountLock extends Vue
{
	data()
	{
		return {
			model: {
				status: AccountState.Unlocked,
			},
			AccountState: AccountState
		};
	}

	mounted()
	{
		const db = new DB();

		db.getStatus((status) =>
		{
			(this as any).model.status = status;
		});
	}
}
